<template>
  <div class="main-contents">
    <div id="sm-menu">
      <img v-on:click="closeMenu()" src="../assets/close.png" id="close" alt="オンライン専門ZOOMコンパニオン「ズムトーーーク☆」">
      <ul>
        <a href="/"><li class="hover">トップページ</li></a>
        <a href="/menu"><li class="hover">料金システム</li></a>
        <a href="/companion"><li class="hover">コンパニオン</li></a>
        <a href="/service"><li class="hover">サービス紹介</li></a>
        <a href="/contact"><li class="hover">お問い合わせ</li></a>
      </ul>
    </div>
    <Header/>
    <div class="information-contents">
      <p class="subTitle-row">コンセプト</p>
      <Information/>
    </div>
    <div class="information-contents">
      <p class="subTitle-row">本日の出勤</p>
      <Today/>
    </div>
    <div class="information-contents">
      <p class="subTitle-row">ご利用方法</p>
      <Process/>
    </div>
    <div class="information-contents">
      <p class="subTitle-row">運営情報</p>
      <BusinessHour/>
    </div>
    <Footer/>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.label-row{
  background-color:rgba(255,255,127,0.7);
 color: #333333;
  margin:0px;
}
header li {
  display: inline-block;
  margin-right: 36px;
  margin-left: 36px;
}
ul {
  padding :0px;
}
a{
  color: white;
  text-decoration: none;
  font-size:24px;
}
.hover {
  display: inline-block;
  position: relative;
  text-decoration: none;
}
.hover::after {
  position: absolute;
  content: '';
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background: white;
  transition: all 0.3s ease 0s;
}
.hover:hover {
  cursor: pointer;
}
.hover:hover::after {
  width: 100%;
}
.subTitle-row{
 background-image: url(../assets/bg-title.jpg);
background-size:cover;
  height: 50px;
  line-height: 50px;
 color:white;
 box-shadow: 4px 4px #005FFF;
  width: 70%;
  margin:36px auto;
  font-size:24px;
  border-radius: 5px 5px 5px 5px;
  font-weight: bold;
  border: 5px solid  white;
}
.information-contents{
  margin-bottom: 36px;
}
footer{
  background-color: black;
}
#clacker{
  position: fixed;
  top:400px;
  right: 16px;
  width: 200px;
}
#wine{
  position: fixed;
  bottom: 100px;
  left: 100px;
  height: 200px;
  display: none;
}
#sm-menu{
  background-color:rgba(0,0,0,0.9);
}
#close{
display: block;
width: 64px;
height:64px;
position: absolute;
top:16px;
right:16px;
}
@media ( max-width : 680px ){
  a{
    color: #555555!important;
   font-weight: bold;
  text-decoration: none;
}
  #sm-menu li{
    display: block;
   background-image: url(../assets/bg-body.jpg);
    color: #555555!important;
     margin-left: 16px;
     margin-right: 16px;
    margin-top: 16px;
     margin-bottom: 16px;
     font-size:24px;
     line-height: 70px;
  border-radius: 10px 10px 10px 10px;
  height: 70px;
  }
  #sm-menu  li a{
   color: white;
  text-decoration: none;
  font-size:24px;
  line-height:70px;
}
  #sm-menu ul{
    margin-top: 100px;
     color: #555555!important;

  }
  .subTitle-row{
    width: 90%;
  }
  #clacker{
  width: 0px;
  height: 0px;
}
#wine{
  width: 0px;
  height: 0px;
}
}
</style>

<script>
import Header from './common/Header'
import Information from './Information'
import Process from './Process'
import Today from './Today'
import BusinessHour from './BusinessHour'
import Footer from './common/Footer'

export default {
  name: 'app',
  components: {
    Information, Today, Header, Footer, Process, BusinessHour
  },
  meta: [
    { name: 'description', content: 'オンラインで現役コンパニオンと飲食しながら楽しくおしゃべりができるサービスです。お客様を笑顔にする事がモットーのコンパニオンが全力でお客様と宅飲みトーーークします。お試しコース10分からでも楽しいので見てください。' },
    { name: 'keywords', content: 'オンライン,コンパニオン,ZOOM,おしゃべり,ズムトーーーク' }
  ],
  data () {
    return {
      scrollY: 0
    }
  },
  mounted () {
    window.addEventListener('scroll', this.calculateScrollY)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.calculateScrollY)
  },
  methods: {
    calculateScrollY () {
    },
    closeMenu: function () {
      document.getElementById('sm-menu').style.display = 'none'
      document.getElementById('sm-menu-icon').style.display = 'block'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Top.vue